module.exports = __webpack_public_path__ + "static/assets/b85e066f510dd21ad5c57c66944a5fcf.png";